// The 911 page (DESIGN.md "911 page and 911 contacts", spec sections 4.1 and 4.3, story TC15):
// offices and their networks, proposals, where Kite places each person, and the 911 contacts.
// The shared typed client (packages/api-client, `e911Admin`) over the console's session. Admins
// only; the server answers 403 to anyone else.
import { queryOptions } from "@tanstack/react-query";
import { e911Admin } from "@vd/api-client";
import { transport } from "./transport";

export type ContactMember = e911Admin.ContactMember;
export type EmergencyContacts = e911Admin.EmergencyContacts;
export type EmergencyLocationsPage = e911Admin.EmergencyLocationsPage;
export type EmergencyPlace = e911Admin.EmergencyPlace;
export type LocationSource = e911Admin.LocationSource;
export type Office = e911Admin.Office;
export type OfficeNetwork = e911Admin.OfficeNetwork;
export type PersonPlace = e911Admin.PersonPlace;

export const e911 = new e911Admin.EmergencyAdminApi(transport);

export const e911Keys = {
  page: ["admin", "e911", "page"] as const,
  contacts: ["admin", "e911", "contacts"] as const,
};

export const e911PageQuery = queryOptions({
  queryKey: e911Keys.page,
  queryFn: ({ signal }) => e911.page(signal),
});

export const e911ContactsQuery = queryOptions({
  queryKey: e911Keys.contacts,
  queryFn: ({ signal }) => e911.contacts(signal),
});
